import styled from 'styled-components';

interface ChipWrapperProps {
  $hasRightSpace?: boolean;
}

export const ChipWrapper = styled.div<ChipWrapperProps>(
  ({ theme: { size }, $hasRightSpace = false }) => ({
    paddingRight: $hasRightSpace ? size.units(1) : 0,
  }),
);
